/**
 * 한 page 실행의 단조 시계 (TASK-2026-004 CR-02).
 *
 * epoch 시각은 표시·진단에만 쓰고, 판정 가능한 시간 차는 `performance.now()` 계열을
 * 기준점에서 뺀 값으로 만든다. reload/navigation은 모듈을 다시 실행하므로 새 segment다.
 */

import type { EventClock } from '../telemetry/events';

export interface PageClockOptions {
  readonly epochNow?: () => number;
  readonly monotonicNow?: () => number;
  readonly random?: () => number;
}

export interface PageClock {
  readonly id: string;
  readonly startedAt: number;
  event(): EventClock;
}

export function createPageClock(options: PageClockOptions = {}): PageClock {
  const epochNow = options.epochNow ?? Date.now;
  const monotonicNow = options.monotonicNow ?? (() => performance.now());
  const random = options.random ?? Math.random;
  const startedAt = epochNow();
  const monotonicOrigin = monotonicNow();
  const nonce = Math.floor(random() * 0x1_0000_0000).toString(36);
  const id = `seg-${Math.max(0, Math.round(startedAt)).toString(36)}-${nonce}`;
  return Object.freeze({
    id,
    startedAt,
    event: () => ({
      segmentId: id,
      elapsedMs: Math.max(0, Math.round(monotonicNow() - monotonicOrigin)),
    }),
  });
}

/** 이 문서를 연 page 하나가 공유하는 clock segment. */
export const PAGE_CLOCK = createPageClock();
